import { DecimalPipe } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CatalogService, DowntimeDashboard } from './catalog.service';

@Component({
  standalone: true,
  selector: 'ain-cmms-downtime-dashboard',
  imports: [DecimalPipe, RouterLink, AinPageComponent, AinStateComponent, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('catalog.cmms.downtime.title')" [description]="t('catalog.cmms.downtime.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('catalog.loading')" />
      } @else if (!dashboard()) {
        <ain-state type="error" [title]="t('catalog.unavailable')" />
      } @else {
        <div class="toolbar">
          <a routerLink="/cmms/work-orders">{{ t('catalog.action.backToList') }}</a>
          <button pButton type="button" [label]="t('catalog.action.refresh')" severity="secondary" (click)="load()"></button>
        </div>
        <section class="summary-grid">
          <article><strong>{{ t('catalog.cmms.downtime.openCount') }}</strong><span>{{ dashboard()!.openDowntimeCount }}</span></article>
          <article><strong>{{ t('catalog.cmms.downtime.hours30d') }}</strong><span>{{ dashboard()!.totalDowntimeHoursLast30Days | number:'1.1-1' }}</span></article>
        </section>
      }
    </ain-page>
  `,
  styles: [`
    .toolbar { display: flex; gap: 8px; margin-bottom: 12px; align-items: center; }
    .summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; }
    .summary-grid article { display: grid; gap: 4px; padding: 16px; background: #f8fafc; border-radius: 8px; }
  `]
})
export class CmmsDowntimeDashboardComponent implements OnInit {
  private readonly service = inject(CatalogService);
  private readonly localization = inject(LocalizationService);

  readonly loading = signal(true);
  readonly dashboard = signal<DowntimeDashboard | null>(null);

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading.set(true);
    this.service.getDowntimeDashboard().subscribe({
      next: data => { this.dashboard.set(data); this.loading.set(false); },
      error: () => { this.dashboard.set(null); this.loading.set(false); }
    });
  }

  t(key: string): string { return this.localization.translate(key); }
}
